import { createIconComponent } from '../../factory/create-icon-component';
export const NewReorderIcon = createIconComponent(
  'NewReorderIcon',
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21.0007 10.0002V9.71796C21.0007 8.72693 21.0007 8.23142 20.8585 7.78617C20.7327 7.39216 20.5268 7.02843 20.2536 6.71781C19.945 6.36681 19.5201 6.11187 18.6703 5.60199L13.4703 2.48199C12.5724 1.94325 12.1235 1.67388 11.6442 1.56864C11.2203 1.47554 10.7812 1.47554 10.3573 1.56864C9.878 1.67388 9.42905 1.94325 8.53115 2.48199L3.33115 5.60199C2.48135 6.11187 2.05646 6.36681 1.74782 6.71781C1.47469 7.02843 1.26875 7.39216 1.14292 7.78617C1.00073 8.23142 1.00073 8.72693 1.00073 9.71796V14.2825C1.00073 15.2736 1.00073 15.7691 1.14292 16.2143C1.26875 16.6083 1.47469 16.9721 1.74782 17.2827C2.05646 17.6337 2.48135 17.8886 3.33115 18.3985L7.6674 21.0002L9.76594 22.2594C10.2149 22.5287 10.4394 22.6634 10.679 22.716C10.891 22.7626 11.1105 22.7626 11.3225 22.716C11.5621 22.6634 11.7866 22.5287 12.2355 22.2594L13.9174 21.2502"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.50085 9.50031L12.2282 6.00031"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.0009 12.5002L20.0009 7.00024M11.0009 12.5002L2.00085 7.00024M11.0009 12.5002V22.5002"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.4983 15.2921V13.8338M15.4983 15.2921C15.4983 15.2921 16.8872 13.0004 19.665 13.0004C20.4259 13.0004 21.1368 13.202 21.7483 13.5544M15.4983 15.2921H16.9566M22.415 18.0421C22.415 18.0421 20.9661 20.3338 18.665 20.3338C17.906 20.3338 17.1945 20.1309 16.5816 19.7763M22.415 18.0421H20.9566M22.415 18.0421V19.5004"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>,
);
